import axios from 'axios';
import ApiGet from '../sections/mainheader/apiget';

class UserLoginService {

    constructor(apiUrl) {
        this.GetApiUrl = apiUrl;
        this.UserLogin = (payload) => (axios.post(`${this.GetApiUrl}Login/UserLogin`, payload));
    }
}
export default ApiGet().then((apiUrl) => new UserLoginService(apiUrl));
